var _path, _rect, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32354 19.9444H2.60134H1.99023V19.3333V14.8484C1.99023 12.1462 2.6908 9.0176 5.32608 7.56487C6.43844 6.95167 7.79046 6.5 9.32354 6.5C10.8566 6.5 12.2086 6.95167 13.321 7.56487C15.9563 9.0176 16.6568 12.1462 16.6568 14.8484V19.3333V19.9444H16.0457H9.32354Z",
    fill: "#F46940"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.767578,
    y: 19.333,
    width: 17.111,
    height: 3.66667,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32227 0C9.87455 0 10.3223 0.447715 10.3223 1V4.66667C10.3223 5.21895 9.87455 5.66667 9.32227 5.66667C8.76998 5.66667 8.32227 5.21895 8.32227 4.66667V1C8.32227 0.447715 8.76998 0 9.32227 0Z",
    fill: "#FEA509"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5108 2.73738C17.9013 3.12791 17.9013 3.76107 17.5108 4.1516L14.9181 6.74432C14.5276 7.13485 13.8944 7.13485 13.5039 6.74432C13.1134 6.3538 13.1134 5.72063 13.5039 5.33011L16.0966 2.73738C16.4871 2.34686 17.1203 2.34686 17.5108 2.73738Z",
    fill: "#FEA509"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.28313 2.73738C0.892606 3.12791 0.892606 3.76107 1.28313 4.1516L3.87584 6.74432C4.26637 7.13485 4.89953 7.13485 5.29005 6.74432C5.68058 6.3538 5.68058 5.72063 5.29005 5.33011L2.69734 2.73738C2.30682 2.34686 1.67365 2.34686 1.28313 2.73738Z",
    fill: "#FEA509"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1582 8.94434C12.1767 9.35174 14.2137 10.8999 14.2137 13.8332",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/reportIcon.b9fdb1a2b3d36c75b6062b72f49e9f50.svg";
export { ForwardRef as ReactComponent };